import * as React from "react";
import { memo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUnmaximize = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 11,
	height: 11,
	viewBox: "0 0 11 11",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "m11 8.7978h-2.2021v2.2022h-8.7979v-8.7978h2.2021v-2.2022h8.7979zm-3.2979-5.5h-6.6012v6.6011h6.6012zm2.1968-2.1968h-6.6012v1.1011h5.5v5.5h1.1011z",
		strokeWidth: .275
	})
});
const Memo = memo(SvgUnmaximize);
export default Memo;
